/**
 * Determines the exact locale (region) based on the base language
 * and the user's system time zone.
 *
 * @param {string} baseLang - The base language code (e.g., 'en', 'es', 'de').
 * @return {string} The region-specific locale code (e.g., 'en-US', 'es-GT', 'de-DE').
 */
export function getRegionLocale(baseLang: string): string {
  // Handle languages that do not require time zone validation
  if (baseLang === 'en') return 'en-US'
  if (baseLang === 'de') return 'de-DE'

  // Specific handling for Spanish based on time zone
  if (baseLang === 'es') {

    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    switch (userTimeZone) {
      case 'America/Guatemala':
        return 'es-GT'
      case 'America/Asuncion':
        return 'es-PY'
      case 'Europe/Madrid':
        return 'es-ES'
      default:
        return 'es-GT'
    }
  }

  return baseLang
}
